<form [formGroup]="searchForm">
  <div class="louer">
    <div class="form-group">
      <div class="radio-container">
        <div>
          <label class="form-label" for="checkdistance1">Ville</label>&nbsp;
          <input type="radio" class="form-check-input" name="checkdistance" id="checkdistance1" value="1"
                 (change)="onCheckboxDistance($event)" checked>
        </div>
        <div>
          <label class="form-label" for="checkdistance2">Distance</label>&nbsp;
          <input type="radio" class="form-check-input" name="checkdistance" id="checkdistance2" value="2"
                 (change)="onCheckboxDistance($event)">
        </div>

      </div>
      <div class="row row-cols-md-2 row-cols-sm-1">
        <div class="form-group">
          <div>
            <label class="form-label" for="locality">Localité</label>
            <div class="container-search-input">
              <span class="close-search-result" *ngIf="searchedAddresses.length > 0"
                    (click)="cancelSearchingAddress()">×</span>
              <input #locality type="search" class="form-control" id="locality" placeholder="Où souhaitez-vous louer ?"
                     autocomplete="off" formControlName="locality" aria-describedby="localitiesHelp"
                     [ngClass]="{ 'is-invalid': submitted && f.locality.errors }"/>
              <div *ngIf="submitted && f.locality.errors" class="invalid-feedback">
                <div *ngIf="f.locality.errors.required">Champ obligatoire</div>
              </div>
            </div>
            <div *ngIf="searchedAddresses.length > 0" class="result-localities-container">
              <ul class="list-group list-group-result">
                <li *ngFor="let locality of searchedAddresses" class="list-group-item elem-result-item"
                    (click)="chooseLocality(locality)">
                  {{ locality.ville }} {{ locality.nom_commune }} {{ locality.code_postal }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="checkdistance">
          <div>
            <label class="form-label" for="distance">
              Distance
            </label>
            <input type="number" class="form-control" id="distance" formControlName="distance" placeholder="Ex : 10"
                   [ngClass]="{ 'is-invalid': submitted && f.distance.errors }" />
            <div *ngIf="submitted && f.distance.errors" class="invalid-feedback">
              <div *ngIf="f.distance.errors.required">Champ obligatoire</div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div>
            <label class="form-label" for="budget">Budget maximum</label>
            <input type="number" class="form-control" id="budget" placeholder="Ex : 1 000" formControlName="budget"
                   [ngClass]="{ 'is-invalid': submitted && f.budget.errors }"/>
            <div *ngIf="submitted && f.budget.errors" class="invalid-feedback">
              <div *ngIf="f.budget.errors.required">Champ obligatoire</div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div>
            <label class="form-label" for="type">Type de bien</label>
            <select class="form-control form-select" id="type" formControlName="type"
                    [ngClass]="{ 'is-invalid': submitted && f.type.errors }">
              <option value="">Tous les types</option>
<!--              <option value="1">Appartement</option>-->
<!--              <option value="2">Maison</option>-->
            </select>
            <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
              <div *ngIf="f.type.errors.required">Champ obligatoire</div>
            </div>
          </div>
        </div>
        <div class="form-group form-btn">
          <div class="btn-recherche-rapide">
            <button type="button" class="btn btn-gold" (click)="submitFormSearch()">Rechercher</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
